import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=1735ea5a&scoped=true"
import script from "./HelpText.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HelpText.vue?vue&type=style&index=0&id=1735ea5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735ea5a",
  null
  
)

export default component.exports